<template>
  <div class="d-flex justify-end py-3 px-4">
    <v-tooltip v-model="showTooltip" top>
      <template  v-slot:activator="{ props }">
        <v-btn @click="closeSelection" v-bind="props" color="error" class="mr-auto" text>
          <h5>
            {{ $t('mapDrawing.close') }}
          </h5>
        </v-btn>
      </template>
      <span>
        {{ $t('mapDrawing.tooltipCloseToShowGroupedServices') }}
      </span>
    </v-tooltip>

    <div v-if="hasSelectedAppointments" class="d-flex align-center">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" color="primary" text>
            <h5>
              {{ $t('mapDrawing.bulkActions') }}
            </h5>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item @click="openModal('BULK_CANCEL_MODAL')" link>
            <v-icon class="mr-3 grey--text text--lighten-1" style="transform: scale(0.85); opacity: 0.75">
              mdi-calendar-remove-outline
            </v-icon>
            <span class="body-2">
              {{ $t('mapDrawing.cancel') }}
            </span>
          </v-list-item>
          <v-list-item @click="openModal('BULK_RESCHEDULE_MODAL')" link>
            <v-icon class="mr-3 grey--text text--lighten-1" style="transform: scale(0.85); opacity: 0.75">
              mdi-calendar-clock
            </v-icon>
            <span class="body-2">
              {{ $t('mapDrawing.reschedule') }}
            </span>
          </v-list-item>
          <v-list-item v-if="isAdminOrPartner" @click="openModal('BULK_SEND_CONFIRMATION_EMAIL_MODAL')" link>
            <v-icon class="mr-3 grey--text text--lighten-1" style="transform: scale(0.85); opacity: 0.75">
              mdi-email-check-outline
            </v-icon>
            <span class="body-2">
              {{ $t('mapDrawing.sendConfirmationEmail') }}
            </span>
          </v-list-item>
          <v-list-item @click="openModal('BULK_CHANGE_APPOINTMENT_STATUS_MODAL')" link>
            <v-icon class="mr-3 grey--text text--lighten-1" style="transform: scale(0.85); opacity: 0.75">
              mdi-flag-outline
            </v-icon>
            <span class="body-2">
              {{ $t('mapDrawing.changeAppointmentStatus') }}
            </span>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-divider :style="{ opacity: 0.5 }" class="mx-2" vertical />
    </div>

    <v-tooltip v-if="hasGroupId" max-width="240" top>
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="groupHost && attrs" v-on="groupHost && on">
          <v-btn @click="openModal('REMOVE_GROUP_MODAL')" :disabled="groupHost != null" color="error" text>
            <h5>
              {{ $t('mapDrawing.removeGroup') }}
            </h5>
          </v-btn>
        </div>
      </template>
      <span>{{ $t('mapDrawing.removeGroupMessage') }}</span>
    </v-tooltip>

    <div v-if="!hasGroupId" class="d-flex align-center mr-3">
      <v-btn @click="openModal('ADD_TO_GROUP_MODAL')" color="primary" text>
        <h5>
          {{ $t('mapDrawing.addToGroup') }}
        </h5>
      </v-btn>
    </div>

    <v-tooltip v-if="!hasGroupId && !canCreateAGroup" max-width="240" top>
      <template v-slot:activator="{ on }">
          <div v-on="on">
            <v-btn
            @click="$emit('createGroup')"
            disabled
            :loading="isLoading"
            color="primary"
            elevation="0"
          >
            <h5>
              {{ $t('appointment.group.button.create') }}
            </h5>
          </v-btn>
          </div>
      </template>
      <span>
        {{ $t('appointment.group.message.createTip') }}
      </span>
    </v-tooltip>

    <v-btn v-if="!hasGroupId && canCreateAGroup" @click="$emit('createGroup')" :loading="isLoading" color="primary" elevation="0">
      <h5>
        {{ $t('appointment.group.button.create') }}
      </h5>
    </v-btn>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'SelectedMarkersButtons',

  props: {
    hasGroupId: {
      type: Boolean,
      required: false,
    },

    groupHost: {
      type: Object,
      required: false,
    },

    canCreateAGroup: {
      type: Boolean,
      required: false,
    },

    isLoading: {
      type: Boolean,
      required: false,
    },

    selectedAppointments: {
      type: Array,
      required: false,
    },
  },

  computed: {
    hasSelectedAppointments() {
      return this.selectedAppointments.length > 0
    },

    isAdminOrPartner() {
      const roles = localStorage.getItem('access_roles')
      const userRoles = roles?.split(',')
      return userRoles?.includes('ROLE_ADMIN') || userRoles?.includes('ROLE_PARTNER')
    },
  },

  methods: {
    ...mapActions(['openModal']),

    closeSelection() {
      this.$parent.$parent.closeSelection()
    },

    showCloseTooltip() {
      this.showTooltip = true

      setTimeout(() => {
        this.showTooltip = false
      }, 3000)
    }
  },

  data() {
    return {
      showTooltip: false,
    }
  },
}
</script>
